import { Component, ChangeDetectionStrategy } from '@angular/core';
import { HttpErrorComponent } from '../../components/http-error/http-error.component';

@Component({
    selector: 'app-pagenotfound',
    templateUrl: './pagenotfound.component.html',
    imports: [
        HttpErrorComponent
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./pagenotfound.component.scss']
})
export class PagenotfoundComponent {

}
